import { render, staticRenderFns } from "./knowledgeDialog.vue?vue&type=template&id=9a25b23a&scoped=true&"
import script from "./knowledgeDialog.vue?vue&type=script&lang=js&"
export * from "./knowledgeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a25b23a",
  null
  
)

export default component.exports